import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import { ARHistoryFile } from '../dataObjects/ARHistoryFile';
import { PharmaciesIDRequest } from '../dataObjects/PharmaciesIDRequest';


import { oAuth } from '../providers/oAuth';

import { DatePipe } from '@angular/common';

import { GlobalVariable } from '../common/global';

@Component({
    selector: 'app-ArAge',
    templateUrl: './arAge.component.html',
    styleUrls: ['./arAge.component.css']
})
export class ArAge {

    dlgConfirm: boolean
    PharmaciesSelectedValue: string
    loading: boolean
    PrintStatementsARHistoryFile: ARHistoryFile[];
    LastARHistoryFile: ARHistoryFile;

    constructor(private http: HttpClient,
        public dialogRef: MatDialogRef<ArAge>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    onNoClick(): void {
        this.dialogRef.close();
    }
    ngOnInit() {
        this.loading = false;
        this.PharmaciesSelectedValue = this.data.PharmaciesSelectedValue;
        this.GetArHistoryAgingDates();
    }

    private submit() {
        this.dlgConfirm = true;
        this.dialogRef.close();
    }

    GetArHistoryAgingDates() {
        // Request for AR Aging dates
        const token = JSON.parse(sessionStorage.getItem('data'));
        const tokenPayload = <oAuth>(token);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
        };

        let PharmaciesIDRequest: PharmaciesIDRequest = {
            Pharmacy_Id: this.PharmaciesSelectedValue.toString()
        }

        var body = JSON.stringify(PharmaciesIDRequest)

        this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneARHistoryFile", body.toString(), options)
            .subscribe(
            (response) => {
                const resp = <ARHistoryFile[]>response
                this.PrintStatementsARHistoryFile = resp;

                this.LastARHistoryFile  = this.PrintStatementsARHistoryFile.reduce(function (r, a) {
                    return r.AgingDate > a.AgingDate ? r : a;
                });
            },
            (err) => {

            },
            () => {

            }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/ar/arAge.component.ts